import { isPlatform } from '@ionic/react';
import { UserDetails } from '../../../models/userProfile/userProfile.modal';
import { clear, GPSWrapper } from '../../../utils/common';
import { logout } from '../../../actions/Login/action';
import { LogIn } from '../../../models/home/login.model';
import { store } from '../../../store';
import {
  MANAGE_USER_REMOVE_SUCCESS_TEXT,
  MANAGE_USER_TRANSFER_EXIST,
  MANAGE_USER_SUCCESS_MESSAGE,
  MANAGE_USER_TRANSFER_MESSAGE,
  MANAGE_USER_UPDATE_SUCCESS,
  OOPS_MESSAGE,
  MANAGE_USER_REMOVE_FAILURE_TEXT
} from '../../../utils/constants';
import { ToastMessage } from '../../../utils/ToastMessage';

export const userProfileModel = new UserDetails();
const _clear = new LogIn();

export const backToPage = (props: any) => {
  if (props?.isAssignDriver) {
    props.history.push(`${props.module}`, {
      ...props.history.location.state,
      showDriversListFromAddDriver: true
  });
    return true;
  }
  props.history.push(`/app/manage/ManageUser`);
};

export const handleSubmit = (props: any) => (
  payload: any,
  restData: Function
) => {
  const query = userProfileModel.addUser(payload);
  const callback = (success = false) => {
    if (success) {
      restData();
      ToastMessage.show(MANAGE_USER_SUCCESS_MESSAGE);
      backToPage(props);
      return true;
    }
    ToastMessage.show(OOPS_MESSAGE);
  };
  props.addUserAction({
    query,
    callback,
    isCarrierAssign: !!props.isAssignDriver
  });
};

export const handleTransfer = (props: any) => (
  payload: any,
  restData: Function,
  isCarrierSame = false
) => {
  const { name, params } = payload;
  props.resetValidateUser();
  if (isCarrierSame) {
    restData();
    ToastMessage.show(MANAGE_USER_TRANSFER_EXIST);
    backToPage(props);
    return true;
  }
  const query = userProfileModel.transferMember(params);
  const callback = (success = false, message = OOPS_MESSAGE) => {
    restData();
    if (success) {
      ToastMessage.open({
        message: MANAGE_USER_TRANSFER_MESSAGE.replace('{{NAME}}', name),
        btnTitle: 'Ok',
        showUndo: true,
        callback: () => {}
      });
    backToPage(props);
    } else {
      ToastMessage.show(message);
    }
  };
  props.transferUserAction({ query, callback });
};

async function azureLogout(props: any) {
  if (isPlatform('capacitor')) {
    GPSWrapper.details.stopGPS();
  }
  await clear();
  await props.authService.logout();
  _clear.clearToken();
  window.localStorage.clear();
  store.dispatch(logout())
}

export const handleDelink = (props: any, isProfile = false) => (
  payload: any
) => {
  const {
    userDetails: { userId }
  } = payload;
  const query = userProfileModel.updateMember(payload);
  const {history} = props;
  const isProfile = history?.location?.state?.isSelf;
  const callback = async (success = false) => {
    if (success) {
      ToastMessage.show(MANAGE_USER_REMOVE_SUCCESS_TEXT);
      if (isProfile) {
        await azureLogout(props);
        return true;
      }
      props.history.push(`/app/manage/ManageUser`, {
        selectedUser: payload.userDetails
      });
      return true;
    }
    ToastMessage.show(MANAGE_USER_REMOVE_FAILURE_TEXT);
  };
  props.delinkUserAction({ query, userId, callback });
};

export const handleUpdateSubmit = (
  props: any,
) => (payload: any, restData: Function) => {
  
  const {history} = props;
  const isProfile = history?.location?.state?.isSelf;
  const query = userProfileModel.updateMember(payload);
  const callback = (success = false, updatedMember: any) => {
    if (success) {
      restData();
      ToastMessage.show(MANAGE_USER_UPDATE_SUCCESS);
      if(props.onSuccess) {
        props.onSuccess();
      }
      if(isProfile){
        props.history.push(`/app/userProfile`);
        return;
      }
      props.history.push(`/app/userProfile`, {
        selectedUser: {...updatedMember, roles: payload.userDetails.roles.map((item: any) => item.value)},
        title: "View Profile"
      });
      return true;
    }
    ToastMessage.show(OOPS_MESSAGE);
  };
  props.updateUserAction({ query, isProfile, callback });
};